import { buildFacetDesignFilterFormOverride } from 'Packages/FacetRest/FacetDesignFilterFormOverride';

export const queryFormMetaOverrideSet = buildFacetDesignFilterFormOverride()

// Hide the boilerplate filter fields that are handled by pagination logic in the table
  .nameOverride(['limit', 'offset', 'sort'], {
    hidden: true,
  })

// Hide types that are not supported in DS yet.
  .typeOverride('multipicklist', {
    hidden: true,
  });
